// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Headline_wrapper__19gVF"};